import { render, staticRenderFns } from "./comp_Home-A-Slider.vue?vue&type=template&id=1c37da74&scoped=true&"
import script from "./comp_Home-A-Slider.vue?vue&type=script&lang=js&"
export * from "./comp_Home-A-Slider.vue?vue&type=script&lang=js&"
import style0 from "./comp_Home-A-Slider.vue?vue&type=style&index=0&id=1c37da74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c37da74",
  null
  
)

export default component.exports